import { Controller } from "stimulus";
import { loadModalUrl } from "../modal/utils";

export default class extends Controller {
  async openModal(event) {
    event.preventDefault();
    loadModalUrl(event.target.href);
  }
}
